import React, {useState, useEffect, useRef} from "react";
import SideBar from "../components/SideBar";
import VerifyForm from "../components/VerifyForm";
import MobileSteps from "../components/MobileSteps";
import PersonalInfoForm from "../components/PersonalInfoForm";
import AddressForm from "../components/AddressForm";
import Footer from "../shared/Footer";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Button from "../components/Button";


export default function Confirmation () {

  const navigate = useNavigate();
  const location = useLocation();
  let agadata = location?.state?.aga;
 
  document.title = 'Get a Handicap - Confirmation';
    
  //if no session exists - dont let users access these pages.

  let screensize = window.innerWidth;
  location.state = null;


  const styled_btn = "max-width:100%; max-height:100%; width:182px;height:80px";

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, [location.pathname]);



    return (<>
        <div className="container App_container" id="confirm">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-9 mx-auto p-4"  id="">
        <div className="row col-12 text-start"> 
          <div className="fs-1 text-center">
           <h1><i className="bi bi-check-circle-fill pe-3" style={{color:"green"}} id=""></i>Welcome to the {agadata[0]['aga_club_name']}</h1>
           </div>
           <p>Your payment has been processed. Check your email for important info about your Handicap ID, receipt, and how to set up your account to post scores.</p>
        </div>
       

        <div className="row mt-4">
             
             
                <div className="col-12 bg-light px-5 border-red-complete"  id="">
                  <span className="badge text-bg-danger fs-6" id="offer">BONUS OFFER</span>
                  <div className="text-primary-emphasis fs-3 fw-bolder">USGA 1894 Club</div>
                  <div className="text-primary-emphasis fs-3 fw-semibold pb-3">$30/year <span className="text-decoration-line-through fs-6 text-secondary"> reg $45/year</span></div>
                  <div className=""><span className="fs-5 pb-3 text-primary-emphasis">Members of the 1894 Club, named for the USGA’s founding year, are committed to ensuring the game thrives for the next 50 years and beyond. 1894 Club members receive all USGA Member benefits.
                  </span></div>
                  <div className="text-primary-emphasis pb-4">
                    <p className="pt-3 text-primary-emphasis fs-5"> 
                      With our thanks, you will receive:
                      </p>
                      <div className="collapse show" id="collapseExample">
                        <ul className="fs-5">
                          <li className="py-1">A one-year USGA membership, with early access to USGA championship tickets, free entry to the USGA Experience and World Golf Hall of Fame, and more</li>
                          <li className="py-1">Your choice of U.S. Open or U.S. Women's Open Presented by Ally Hat</li>
                          <li className="py-1">A year’s subscription to Golf Journal Magazine, the official publication of the USGA</li>
                          <li className="py-1">Home delivery of all eight issues of GOLF magazine and access to InsideGOLF</li>
                          <li className="py-1">Personalized USGA Member bag tag</li>
                          <li className="py-1">25% off Ship Sticks golf club and luggage shipping</li>
                          <li className="py-1">$50 off a swing evaluation or club fitting with GOLFTEC</li>
                        
                        
                        </ul>
                      </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 col-xxl-10 mx-auto pb-5">
                    <img src="../members_offer.jpg" className="img img-fluid"/>
                    </div>

                  <div className="col-12 col-sm-10 mx-auto pb-4">
                    <Link to="https://foundation.usga.org/page/67135/donate/1?utm_source=AGAGC&utm_medium=digitalad&utm_campaign=USGA_Membership" target="_blank" className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit">
                        SUPPORT TODAY
                    </Link>

                </div>
                </div>
              
              
           </div>

        </div>

    </div>
    </> 
    )
}
